/** @format */

import {
	CriteoViewProductsResponse,
	CustomBadge,
	PlpPromoMessages,
	PromoDetailsMap,
	PromoteIQ
} from '@shared/data-access/interfaces';
import { DisplayableProductListData, RefinementUpdateObj } from '@plp/data-access/interfaces';
import { createAction, props } from '@ngrx/store';

// Initializers
export const setInitialPageNumber = createAction(
	'[Product List] Set Initial Page Number',
	props<{ pageNumber: number }>()
);

export const setInitialPageSize = createAction(
	'[Product List] Set Initial Page Size',
	props<{ pageSize: number }>()
);

export const setIsInitialPageLoad = createAction(
	'[Product List] Set is initial Page Load',
	props<{ isInitialPageLoad: boolean }>()
);

// Setters
export const setProductListSEO = createAction('[Product List] SEO Data Received', props<any>());

export const setProductList = createAction('[Product List] Data Received', props<any>());

export const setSkeletonLoader = createAction(
	'[Product List] Set Skeleton Loader Status',
	props<{ isSkeletonLoaderVisible: boolean }>()
);

export const setIsFilterSidePanelOpen = createAction(
	'[Product List] Set Filters side panel open Status',
	props<{ isFilterSidePanelOpen: boolean }>()
);

export const setProductAvailability = createAction(
	'[Product List] Availability Data Received',
	props<any>()
);

export const setProductListPromo = createAction(
	'[Product List] Promotion Data Received',
	props<{ productPromotion: PromoDetailsMap | PlpPromoMessages | null }>()
);

export const setPinnedContent = createAction('[Product List] Set Pinned Content', props<any>());

export const setPiqProducts = createAction(
	'[Product List] Set Promote IQ Products',
	props<{ piqProducts: PromoteIQ[] }>()
);

export const setCriteoProducts = createAction(
	'[Product List] Set Criteo Products',
	props<{ criteoProducts: CriteoViewProductsResponse }>()
);

export const setSelectedSort = createAction(
	'[Product List] Set Selected Sort Value',
	props<{ selectedSort: { label: string; value: number } }>()
);

export const updateSelectedSort = createAction(
	'[Product List] Update Selected Sort Value From Sort Component',
	props<{ selectedSort: { label: string; value: number } }>()
);

export const setPageNumber = createAction(
	'[Product List] Set Current Page Number',
	props<{ pageNumber: number }>()
);

export const setPageSize = createAction(
	'[Product List] Set Current Page Size',
	props<{ pageSize: number }>()
);

export const setPageSizeAndPageNumber = createAction(
	'[Product List] Set Current Page Size and Reset Page Number',
	props<{ pageNumber: number; pageSize: number }>()
);

export const setHomrBannerData = createAction('[Product List] Set HomR Banner Data', props<any>());

export const setIsProductListPageLoading = createAction(
	'[Product List] Set whether the PLP page is currently loading and should show the loading spinner',
	props<{ isProductListPageLoading: boolean }>()
);

export const setIsProductListPageValid = createAction(
	'[Product List] Set whether current page is a valid PLP',
	props<{ isProductListPageValid: boolean }>()
);

export const setDisplayableProductListData = createAction(
	'[Product List] DisplayableProductListData - Set the combined list of ProductVO, PinnedContentSpots, and PIQProductData for display',
	props<{ displayableProductListData: DisplayableProductListData }>()
);

// filterType and filterValue will remain here
export const setFiltering = createAction(
	'[Product List] Set Filtering',
	props<{ selectedFilters: Record<string, string[]> }>()
);

export const setAllFilters = createAction(
	'[Product List] Set Initial Filtering',
	props<{ selectedFilters: Record<string, string[]> }>()
);

export const removeAllFilters = createAction('[Product List] Remove all Filtering');

export const setMlBypass = createAction(
	'[Product List] Set ML Bypass',
	props<{ mlBypass: boolean }>()
);
export const setSnbAudience = createAction(
	'[Product List] Set the snbAudience header param for analytics testing',
	props<{ snbAudience: string }>()
);

export const refreshProductList = createAction('[Product List] Refresh Product List');

export const setRefinementUpdateObj = createAction(
	'[Product List] send resultViewUpdate analytics',
	props<{ refinementUpdateObj: RefinementUpdateObj | undefined }>()
);

export const productListResolverFeatureFlagsSet = createAction(
	'[Product List] Set Feature Flags on Page Load',
	props<{ featureFlags: Record<string, boolean> }>()
);

export const productListContainerFeatureFlagsSet = createAction(
	'[Product List] Set Feature Flags',
	props<{ featureFlags: Record<string, boolean> }>()
);

export const featureConfigCustomBadgesSet = createAction(
	'[Feature Config] Custom Badges Set',
	props<{
		customBadges: Record<string, CustomBadge>;
	}>()
);
